export default {
  hexToRgba(hex: string, alpha = 1) {
    if (hex.match(/^rgba/)) return hex

    const rgbCodes = hex.replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`
    )

    if (rgbCodes) {
      const values = rgbCodes.substring(1).match(/.{2}/g)
      if (values) {
        const rgbArray = values.map((x) => parseInt(x, 16))
        return `rgba(${rgbArray[0]},${rgbArray[1]},${rgbArray[2]},${alpha})`
      }
      throw new Error("hex passed is not a valid rgba")
    }

    throw new Error("hex passed is not a valid rgba")
  },

  rgbToHex(r: number, g: number, b: number) {
    const hexValues = [r, g, b]
      .map((x) => {
        const hex = x.toString(16)
        return hex.length === 1 ? `0${hex}` : hex
      })
      .join("")

    return `#${hexValues}`
  },

  isLightColor(hex: string): boolean {
    const rgbString = this.hexToRgba(hex)
    const match = rgbString.match(/rgba?\((\d+),(\d+),(\d+)(?:,\d*\.?\d+)?\)/)
    if (!match || !match[1] || !match[2] || !match[3]) {
      throw new Error("Invalid RGB(A) string from hexToRgba")
    }

    const r = parseInt(match[1], 10)
    const g = parseInt(match[2], 10)
    const b = parseInt(match[3], 10)

    // Calculate luminance using the standard formula
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b

    // Colors with luminance greater than 140 are considered light
    return luminance > 140
  },
}
